import React, { PropsWithChildren } from 'react';

import type{ StepsLabels } from './components/types';

import { Header } from './components/Header';
import { StepperContext, useStepperContextValue } from './context';

export type StepperProps = PropsWithChildren<{
  totalSteps: number;
  className?: string;
  visibility?: boolean;
  hint?: Record<string, string>;
  stepsLabels?: StepsLabels;
}>;

// Todo https://jira.tennisi.it/browse/WEB-1655
export const Stepper: React.FC<StepperProps> = ({
  totalSteps,
  className,
  children,
  visibility = false,
  hint,
  stepsLabels,
}) => {
  const stepperContextValue = useStepperContextValue();

  return (
    <StepperContext.Provider value={stepperContextValue}>
      {visibility && (
        <Header
          totalSteps={totalSteps}
          hint={hint}
          className={className}
          stepsLabels={stepsLabels} />
      )}
      {children}
    </StepperContext.Provider>
  );
};
